<template>
  <svg class="icon-cross" v-on="$listeners" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.2896 0.710353C20.3425 -0.236783 18.8069 -0.236783 17.8598 0.710353L11.0003 7.56986L4.14075 0.710352C3.19362 -0.236784 1.658 -0.236784
       0.710868 0.710352C-0.236268 1.65749 -0.236267 3.1931 0.710869 4.14023L7.57038 10.9997L0.710352 17.8598C-0.236784 18.8069 -0.236784 20.3425
        0.710352 21.2896C1.65749 22.2368 3.1931 22.2368 4.14024 21.2896L11.0003 14.4296L17.8603 21.2896C18.8074 22.2368 20.343 22.2368 21.2902
         21.2896C22.2373 20.3425 22.2373 18.8069 21.2902 17.8598L14.4301 10.9997L21.2896 4.14024C22.2368 3.1931 22.2368 1.65749 21.2896 0.710353Z"
      fill="#919298" fill-opacity="0.6"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconCross'
  }
</script>
